import { render, staticRenderFns } from "./DevSwitch.vue?vue&type=template&id=cdf07244"
import script from "./DevSwitch.vue?vue&type=script&lang=js"
export * from "./DevSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports